export default __webpack_public_path__ + "static/media/shutterstock_1020434296.7f7388b9.jpg";